import { Table } from '@loadsmart/loadsmart-ui'

import type { Accessorial, AccessorialRate } from '../domain/Accessorial'
import type { Currency } from '../domain/Currency'
import { getFormattedCurrency } from '../presenters/lanePresenter'
import { RfpAccessorialRow } from './RfpAccessorialRow'

export type RfpAccessorialListProps = {
  rfpId: string
  currency: Currency
  accessorials: Array<Accessorial>
  accessorialRates: Array<AccessorialRate>
  disabled: boolean
  onRowBlur?: (rate: AccessorialRate) => void
}

export function RfpAccessorialList({
  rfpId,
  currency,
  accessorials,
  accessorialRates,
  onRowBlur,
  disabled,
}: RfpAccessorialListProps) {
  const formattedCurrency = getFormattedCurrency(currency)

  const commonRowProps = {
    rfpId,
    currency,
    accessorialRates,
    onBlur: onRowBlur,
    disabled: disabled,
  }

  return (
    <Table>
      <Table.Head>
        <Table.Row>
          <Table.HeadCell>Accessorials</Table.HeadCell>
          <Table.HeadCell />
          <Table.HeadCell alignment="right">Last Rate</Table.HeadCell>
          <Table.HeadCell alignment="right">Rate ({formattedCurrency})</Table.HeadCell>
          <Table.HeadCell alignment="right">Notes</Table.HeadCell>
        </Table.Row>
      </Table.Head>
      <Table.Body>
        {accessorials.map(({ type, label, shipperNotes }) => (
          <RfpAccessorialRow
            key={type}
            accessorialType={type}
            name={label}
            shipperNotes={shipperNotes}
            {...commonRowProps}
          />
        ))}
      </Table.Body>
    </Table>
  )
}
